import React, { Component } from "react";
//import SocketJsClient from 'react-stomp';
import API from "../conf/API";
import SockJS from 'sockjs-client'
import { Client } from "@stomp/stompjs";
import { JSEvent, Events } from "../utils/JSEvent";
import DataCenter from "./DataCenter";

class WebSocketClient {
    constructor({ name, url }) {
        this.name = name;
        this.url = url;
        this.loginInfo = {};
        this.client = null;
        /**
         * 所有已订阅的消息对应的subscribe实例，为了取消订阅用
         * key = topic, value = subscribe
         */
        this.subscribeTopics = {}

        /**
         * 所有已订阅的消息对应的回调函数列表，列表为空则取消订阅
         * key = topic, value = [msgHandlers], handler = function(topic, message) 
         */
        this.topicHandlers = {};

        /**
         * 还没连接成功时注册的订阅消息，连接成功后立即订阅
         * [{topic,handler}]
         */
        this.subscribeWaittingQueue = [];
    }


    isConnected() {
        if (this.client == null) {
            return false;
        }
        return this.client.connected;
    }

    connect(id, key, clientModuleId) {
        const onConnected = (frame) => {
            console.log(`websocket(${this.name}) connected`);
            //console.log("subscribe waitting queue length: " + this.subscribeWaittingQueue.length);
            JSEvent.emit(Events.Connection.Connected);
            this.processWaittingQueue();
        }

        const onDisconnect = (evt) => {
            console.log(`websocket(${this.name}) Disconnected`);
            JSEvent.emit(Events.Connection.Disconnected);

            //将现有已订阅的topic，重新放入waittingQueue中，以便重连后重新订阅
            for (const topic in this.topicHandlers) {
                const handlers = this.topicHandlers[topic];
                handlers.forEach(h => {
                    this.subscribeWaittingQueue.push({ topic: topic, handler: h });
                })
            }

            //console.log("subscribe waitting queue length: " + this.subscribeWaittingQueue.length);

            this.subscribeTopics = {}
            this.topicHandlers = {};
        }


        let client = new Client({
            debug: str =>
                console.log("Stomp Client Debug:", str),
            onConnect: onConnected,
            onDisconnect: onDisconnect,
            onWebSocketClose: onDisconnect,
            connectHeaders: { accountId: id, loginKey: key, serviceId: DataCenter.serviceId() },
        });

        client.webSocketFactory = () => new SockJS(this.url);
        client.activate();
        this.loginInfo = { accountId: id, loginKey: key, clientModuleId: clientModuleId };
        this.client = client;
    }

    // subscribe(topic, handler) {
    //     // if (WebSocketClient.client != null) {
    //     //     WebSocketClient.client.subscribe(topic, handler)
    //     // }
    //     subscribe(topic, handler);
    // }

    // unsubscribe(topic, handler) {
    //     unsubscribe(topic, handler);
    // }

    subscribe(topic, handler) {
        if (this.isConnected()) {
            this.subscribeTopic(topic, handler);
        } else {
            this.subscribeWaittingQueue.push({ topic: topic, handler: handler });
        }
    }

    /**
     * 取消指定topic的订阅handler，如果handler为空，则取消此topic的全部订阅
     * @param {String} topic 
     * @param {function} handler 
     */
    unsubscribe(topic, handler) {
        if (this.isConnected()) {
            let { subscribeTopics, topicHandlers, client } = this;
            let handlers = topicHandlers[topic];

            if (handlers != null) {
                if (handler == null) {
                    handlers.splice(0, handlers.length);
                } else {
                    let index = handlers.indexOf(handler);
                    if (index != -1) {
                        handlers.splice(index, 1);
                    }
                }
                if (handlers.length == 0) {
                    const ss = subscribeTopics[topic];
                    if (ss != null) {
                        ss.unsubscribe();
                    }
                    subscribeTopics[topic] = null;
                }
            }
        }
    }
    processWaittingQueue() {
        this.subscribeWaittingQueue.forEach(v => {
            this.subscribeTopic(v.topic, v.handler);
        })
        this.subscribeWaittingQueue = [];
    }

    subscribeTopic(topic, handler) {
        let { subscribeTopics, topicHandlers, client } = this;
        if (subscribeTopics[topic] == null) {
            subscribeTopics[topic] = client.subscribe(topic, message => this.topicHandler(topic, message));
        }

        let hs = topicHandlers[topic];
        if (hs == null) {
            hs = topicHandlers[topic] = [];
        }
        hs.push(handler);
    }

    topicHandler(topic, message) {
        let { topicHandlers } = this;
        var hs = topicHandlers[topic];
        if (hs != null) {
            hs.forEach(h => {
                h(topic, message);
            });
        }
    }
}

export default WebSocketClient;

// export default class WebSocketClient extends Component {
//     constructor(props) {
//         super(props);
//     }

//     onMessage(msg, topic) {
//         console.log(`receive message`, msg, `on topic ${topic}`);
//     }

//     render() {
//         const header = { accountId: 3, key: 'aaaa-bbbb-cccc-dddd-ffff' };
//         return (
//             <div>
//                 <SocketJsClient
//                     url={API.websocket_url()}
//                     topics={API.websocket_topics}
//                     onMessage={this.onMessage}
//                     headers={header}
//                 />
//             </div>
//         );
//     }
// }



